import { FC } from 'react';
import {
  WbAlert,
  WbDrawer,
  WbDrawerContent,
} from '@agilelab/plugin-wb-platform';
import { Typography } from '@material-ui/core';
import { RoleForm, RoleFormProps, RoleFormType } from './RoleForm';

interface NewEditRoleDrawerProps extends RoleFormProps {
  defaultValues?: RoleFormType;
  id?: string;
  error?: Error;
  openDrawer: boolean;
}

export const NewEditRoleDrawer: FC<NewEditRoleDrawerProps> = ({
  onSubmit,
  dataState,
  openDrawer,
  setOpenDrawer,
  error,
  defaultValues,
}) => {
  return (
    <WbDrawer
      open={openDrawer}
      setOpen={setOpenDrawer}
      size={50}
      title={defaultValues ? 'Update Role' : 'New Role'}
    >
      <WbDrawerContent style={{ padding: 0 }}>
        {error && (
          <WbAlert
            message={{
              title: 'Error',
              type: 'error',
              content: <Typography>{error.message}</Typography>,
            }}
          />
        )}
        <RoleForm
          defaultValues={defaultValues}
          onSubmit={onSubmit}
          dataState={dataState}
          setOpenDrawer={setOpenDrawer}
        />
      </WbDrawerContent>
    </WbDrawer>
  );
};
